import { Card, Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataVehiculo from "./dataVehiculo";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const Vehiculos = ({ listadoVehiculos }) => {
  const { columns, getRows } = dataVehiculo;

  const memoizedRows = useMemo(() => {
    if (listadoVehiculos) {
      const listadoSinBorrar = listadoVehiculos.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoVehiculos]);

  return (
    <Grid container p={2}>
      <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="flex-end">
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Vehículos
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoVehiculos?.filter((item) => !item.aBorrar).length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay vehículos cargados" />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(Vehiculos);

Vehiculos.propTypes = {
  listadoVehiculos: PropTypes.array.isRequired,
};
